<template>
  <div>
    <v-dialog
      v-model="dialogVisible"
      persistent
      width="720">
      <v-card>
        <v-card-title>
          パスワードの初期化
        </v-card-title>
        <v-card-text
          v-if="completed">
          <div>
            確認メールを送信しました<br>
            <br>メール内のリンクをクリックして、パスワードリセットを完了させてください。
          </div>
          <div>＊受信しない場合は迷惑メールフォルダもご確認ください。</div>
        </v-card-text>
        <v-card-text v-else>
          入力したメールアドレスにパスワードの再設定に関するメールを送付します。<br />
          メールアドレスを未設定の場合は協会までご連絡下さい。
          <v-text-field
            v-model="email"
            class="mt-3 ml-5 mr-5"
            label="メールアドレス"
            outlined />
        </v-card-text>
        <v-card-actions v-if="completed">
          <v-spacer />
          <v-btn
            color="default"
            @click.prevent="onCancelClicked">
            戻る
          </v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn
            color="default"
            @click.prevent="onCancelClicked">
            キャンセル
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            @click.prevent="onSubmitClicked">
            送信
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'PasswordReset',

  data() {
    return {
      email: '',
      dialogVisible: true,
      loading: false,
      completed: false,
      errorMessage: '',
    }
  },

  methods: {
    async onSubmitClicked() {
      this.errorMessage = ''
      this.loading = true
      try {
        await window.axios.post('/api/send-reset-password', { email: this.email })

        this.loading = false
        this.completed = true
      } catch (err) {
        this.loading = false
        if (err.response.status === 422) {
          this.errorMessage = 'メールアドレスが見つかりません。'
        }
      }
    },
    onCancelClicked() {
      this.$router.push({ name: 'login' })
    },
  },
}
</script>
